import React, { useState, useEffect, useRef } from 'react';
const PositionsEN = () => {
  const [isVisible, setIsVisible] = useState(false);
  const targetRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      },
      { threshold: 0.1 } // Adjust this threshold as needed
    );

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, []);

  return (<>
    <div
      ref={targetRef}
      className={`hot-position ${isVisible ? 'visible' : ''}`}
      tabIndex="0"
    >
      <div className="hot-position-body">
        <span className="hot-position-type">Message from the owner</span>
        <h3>
        The entire world is being torn apart by the threat of terrorism since October 7 and our rights are jeopardised. <br/>Despite this horrendous situation, our EnbyBase Alliance does our best endeavours to provide a safe place for LGBTQIAN+ Individuals and protect diversity.
        <br/>We strongly condemn the Hamas terrorism that massacred Israeli civilians. Never forget the history!
        </h3>
        <p className={isVisible ? '' : 'visible'}>
        
        </p>
      </div>
      <div className="hot-position-footer">
        <button className="rohm-save">
          <img
            alt="save"
            src="https://www.mossad.gov.il/save-white.svg"
          />
        </button>
        <div className="share-div">
          <div className="multi-select-background" />
        </div>
        <a
          href="https://www.mossad.gov.il/positions/12"
        >
          View Position
        </a>
      </div>
    </div></>
  );
};

export default PositionsEN;
